import { render } from "./App.vue?vue&type=template&id=d991e3be"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=d991e3be&lang=css"

import exportComponent from "/Users/costin/repos/cnstlungu-internal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__